import React, { lazy } from 'react'
import { Redirect, Route, Switch } from 'react-router-dom'

import uid from '../shared/uid'
import WrappedComponent from '../shared/Wrapper'
import { token } from '../util/constants'
import { ternary } from '../util/javascript'
import { loadStateFn } from '../util/localStorage'

const AuthRedirectToRails = lazy(
  () => import('../containers/AuthRedirectToRails'),
)
const MerchantRedirectToRails = lazy(
  () => import('../containers/MerchantRedirectToRails'),
)
const NotFound = lazy(() => import('../containers/NotFound'))
const SignOut = lazy(() => import('../containers/SignOut'))

const SelectComponent = (
  Component,
  props,
  redirectUrl,
  isAuth,
  isUserLoggedIn,
) => {
  const FinalComponent = <Component {...props} />
  const FinalRedirectUrl = <Redirect to={{ pathname: redirectUrl }} />
  if (isAuth)
    return ternary(loadStateFn(token), FinalRedirectUrl, FinalComponent)
  if (isUserLoggedIn)
    return ternary(loadStateFn(token), FinalComponent, FinalRedirectUrl)
  return FinalComponent
}

const Routing = () => {
  const routes = [
    {
      path: ['/', '/sign-up', '/custom'],
      component: AuthRedirectToRails,
      exact: true,
      isAuth: true,
      redirectUrl: '/packaging',
      isWrapperNeeded: false,
    },
    {
      path: ['/signup1'],
      component: AuthRedirectToRails,
      exact: true,
      isAuth: true,
      redirectUrl: '/packaging',
      isWrapperNeeded: false,
    },
    {
      path: ['/signup2'],
      component: AuthRedirectToRails,
      exact: true,
      isAuth: true,
      redirectUrl: '/packaging',
      isWrapperNeeded: false,
    },
    {
      path: ['/signup3'],
      component: AuthRedirectToRails,
      exact: true,
      isAuth: true,
      redirectUrl: '/packaging',
      isWrapperNeeded: false,
    },
    {
      path: '/login',
      component: AuthRedirectToRails,
      isAuth: true,
      redirectUrl: '/packaging',
      isWrapperNeeded: false,
    },
    {
      path: '/forgot-password',
      component: AuthRedirectToRails,
      isAuth: true,
      redirectUrl: '/packaging',
      isWrapperNeeded: false,
    },
    {
      path: '/reset-password',
      component: AuthRedirectToRails,
      isAuth: true,
      redirectUrl: '/packaging',
      isWrapperNeeded: false,
    },
    {
      path: '/reset-password-confirmation',
      component: AuthRedirectToRails,
      isAuth: true,
      redirectUrl: '/packaging',
      isWrapperNeeded: false,
    },
    {
      path: '/build-your-product',
      component: AuthRedirectToRails,
      exact: true,
      isAuth: true,
      redirectUrl: '/',
      isWrapperNeeded: false,
    },
    {
      path: '/connect-store',
      component: MerchantRedirectToRails,
      isUserLoggedIn: true,
      redirectUrl: '/login',
      isWrapperNeeded: false,
    },
    {
      path: '/success',
      component: AuthRedirectToRails,
      isUserLoggedIn: false,
      redirectUrl: '/login',
      isWrapperNeeded: false,
    },
    {
      path: '/success-for-wix',
      component: AuthRedirectToRails,
      isUserLoggedIn: false,
      redirectUrl: '/login',
      isWrapperNeeded: false,
    },
    {
      path: '/success-for-instanceId',
      component: AuthRedirectToRails,
      isUserLoggedIn: false,
      redirectUrl: '/login',
      isWrapperNeeded: false,
      exact: true,
    },
    {
      path: '/success-for-code',
      component: AuthRedirectToRails,
      isUserLoggedIn: false,
      redirectUrl: '/login',
      isWrapperNeeded: false,
      exact: true,
    },
    {
      path: '/success-for-code-wix',
      component: AuthRedirectToRails,
      isUserLoggedIn: false,
      redirectUrl: '/login',
      isWrapperNeeded: false,
      exact: true,
    },
    // Migrated Hotwire merchant pages — hard redirect to Rails monolith
    {
      path: '/packaging',
      component: MerchantRedirectToRails,
      isUserLoggedIn: true,
      redirectUrl: '/login',
      isWrapperNeeded: false,
    },
    {
      path: '/products',
      component: MerchantRedirectToRails,
      isUserLoggedIn: true,
      redirectUrl: '/login',
      isWrapperNeeded: false,
    },
    {
      path: '/product-pricing',
      component: MerchantRedirectToRails,
      isUserLoggedIn: true,
      redirectUrl: '/login',
      isWrapperNeeded: false,
    },
    {
      path: '/get-sales',
      component: MerchantRedirectToRails,
      isUserLoggedIn: true,
      redirectUrl: '/login',
      isWrapperNeeded: false,
    },
    {
      path: '/welcome-survey',
      component: AuthRedirectToRails,
      isUserLoggedIn: true,
      redirectUrl: '/login',
      isWrapperNeeded: false,
    },
    {
      path: '/pricing-plans',
      component: AuthRedirectToRails,
      isUserLoggedIn: true,
      redirectUrl: '/login',
      isWrapperNeeded: false,
    },
    {
      path: '/settings',
      component: MerchantRedirectToRails,
      isUserLoggedIn: true,
      redirectUrl: '/login',
      isWrapperNeeded: false,
    },
    {
      path: '/getting-started',
      component: MerchantRedirectToRails,
      isUserLoggedIn: true,
      redirectUrl: '/login',
      isWrapperNeeded: false,
    },
    {
      path: '/my-custom-products',
      component: MerchantRedirectToRails,
      isUserLoggedIn: true,
      redirectUrl: '/login',
      isWrapperNeeded: false,
    },
    {
      path: '/orders',
      component: MerchantRedirectToRails,
      isUserLoggedIn: true,
      redirectUrl: '/login',
      isWrapperNeeded: false,
    },
    {
      path: '/invoices',
      component: MerchantRedirectToRails,
      isUserLoggedIn: true,
      redirectUrl: '/login',
      isWrapperNeeded: false,
    },
    {
      path: '/custom-labels',
      component: MerchantRedirectToRails,
      isUserLoggedIn: true,
      redirectUrl: '/login',
      isWrapperNeeded: false,
    },
    {
      path: '/direct-and-bulk-orders',
      component: MerchantRedirectToRails,
      isUserLoggedIn: true,
      redirectUrl: '/login',
      isWrapperNeeded: false,
    },
    {
      path: '/purchase-turnkey-store',
      component: MerchantRedirectToRails,
      isUserLoggedIn: true,
      redirectUrl: '/login',
      isWrapperNeeded: false,
    },
    {
      path: '/build-your-store',
      component: MerchantRedirectToRails,
      isUserLoggedIn: true,
      redirectUrl: '/login',
      isWrapperNeeded: false,
    },
    {
      path: '/redirect-purchase-turnkey-store',
      component: MerchantRedirectToRails,
      isUserLoggedIn: true,
      redirectUrl: '/login',
      isWrapperNeeded: false,
    },
    {
      path: '/purchase-media-packages',
      component: MerchantRedirectToRails,
      isUserLoggedIn: true,
      redirectUrl: '/login',
      isWrapperNeeded: false,
    },
    {
      path: '/creative-services',
      component: MerchantRedirectToRails,
      isUserLoggedIn: true,
      redirectUrl: '/login',
      isWrapperNeeded: false,
    },
    {
      path: '/media-packages-history',
      component: MerchantRedirectToRails,
      isUserLoggedIn: true,
      redirectUrl: '/login',
      isWrapperNeeded: false,
    },
    {
      path: '/launch-ads',
      component: MerchantRedirectToRails,
      isUserLoggedIn: true,
      redirectUrl: '/login',
      isWrapperNeeded: false,
    },
    {
      path: '/sign-out',
      component: SignOut,
      exact: true,
      isWrapperNeeded: false,
    },
    {
      path: '*',
      component: NotFound,
    },
  ]
  return (
    <Switch>
      {routes.map(
        ({
          component: Component,
          redirectUrl,
          isAuth,
          isUserLoggedIn,
          isWrapperNeeded,
          ...route
        }) => (
          <Route
            key={uid()}
            {...route}
            render={(props) =>
              SelectComponent(
                ternary(
                  isWrapperNeeded,
                  WrappedComponent(Component),
                  Component,
                ),
                props,
                redirectUrl,
                isAuth,
                isUserLoggedIn,
              )
            }
          />
        ),
      )}
    </Switch>
  )
}
export default Routing
